import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Checkbox, FormControlLabel } from "@mui/material";
import { withLocalizer } from "utilities/withLocalizer";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import { updateCustomQuote } from "services/customQuote/customQuote.service";
import { CONFIGURATION } from "utilities/configuration";

import PromotionEditor from "./promotionEditor";
import ErrorAlert from "../common/errorAlert";
import { Icon } from "__ICON_REFERENCE__";

import "../../customize.scss";


export class CustomizeQuoteSteFour extends Component {
    constructor(props) {
        super(props);
    }

    handlePromotionSelectorChange = (promotion) => {
        let { customQuote } = this.props;
        let { id } = promotion;
        
        this.props.dispatch(updateCustomQuote({
            ...customQuote?.data,
            promotions: customQuote?.data?.promotions?.map(promotion => ({
                ...promotion,
                included: ((promotion && promotion.id === id) ? !promotion.included : promotion.included)
            }))
        }));

    };

    handleAll = (hasSelected) => {
        let { customQuote } = this.props;
        
        this.props.dispatch(updateCustomQuote({
            ...customQuote?.data,
            promotions: customQuote?.data?.promotions?.map(promotion => ({
                ...promotion,
                included: !hasSelected
            }))
        }));
    };

    handlePromotionUpdate = (promotion, index, key, value, tagIndex) => {
        let { customQuote } = this.props;
        let { id } = promotion;

        this.props.dispatch(
            updateCustomQuote({
                ...customQuote?.data,
                promotions: customQuote?.data?.promotions?.map((promotion) => {
                    if (promotion.id === id) {
                        return {
                            ...promotion,
                            placeHolderObjects: promotion.placeHolderObjects?.map((obj, idx) => {
                                if (idx === tagIndex && obj?.data) {
                                    return {
                                        ...obj,
                                        data: {
                                            ...obj.data,
                                            value
                                        }
                                    };
                                }
                                return obj;
                            })
                        };
                    }
                    return promotion;
                })
            })
        );

    };

    render() {
        const { data, customQuote, events, error } = this.props;
        const { currentStep } = data;
        if (currentStep !== 4) {
            return null;
        }

        let hasSelected = customQuote?.data?.promotions?.filter(s => s.included).length > 0;

        const { languageCode } = customQuote?.data;
        const isOutlineIcon = CONFIGURATION.CHECK_CIRCLE_ROUNDED_ICON_IS_OUTLINED;

        return (
            <>
                { customQuote?.data?.promotions && customQuote?.data?.promotions.length > 0 ? 
                    <div className="step-editor">
                        <div className="step-heading">
                            <h4>{ this.props.localize("qma-custom-quote-step-4-heading") }</h4>
                            <div>
                                { this.props.localize("qma-custom-quote-step-4-intro") }
                            </div>
                        </div>
                        <div className="text-right-align margin-top-2x margin-bottom top-command">
                            <Button
                                className="link-button"
                                data-testid={"deselectAllBtn"}
                                onClick={() => this.handleAll(hasSelected)}
                            >
                                { hasSelected ? this.props.localize("qma-deselect-all") : this.props.localize("qma-select-all") }
                            </Button>
                        </div>
                        <div className="custom-quote-editor-container">
                            { customQuote?.data?.promotions.map((promotion, index) => 
                                <div className="promotion-items" key={index}>
                                    <div className="custom-quote-editor-panel-wrapper splitter promotion">
                                        <div className="custom-quote-editor-panel promotion-bar">
                                            <div className="d-flex">
                                                <div className="col-promotion-selector">
                                                    <FormControlLabel className="form-control-label" control={<Checkbox checked={promotion.included} onChange={ () => this.handlePromotionSelectorChange(promotion) } />} label={ this.props.localize("qma-include") } />
                                                </div>
                                                <div className="col-promotion-selected-info">
                                                    {promotion.included ?
                                                        <div className="d-flex">
                                                            <div>
                                                                {isOutlineIcon ? <CheckCircleOutlineRoundedIcon className="selected-icon" /> : <CheckCircleRoundedIcon className="selected-icon" />}
                                                            </div>
                                                            <div className="selected-icon-label">
                                                                { this.props.localize("qma-applied") }
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="custom-quote-editor-panel-wrapper splitter promotion">
                                        <div className="custom-quote-editor-panel promotion-editor">
                                            <div className="d-flex">
                                                <div className="col-promotion-icon" data-testid="promotionicon">
                                                    <div className="promotion-icon" data-testid="promotionicon">
                                                        <Icon
                                                            name="promotion"
                                                            className="icon font-orange"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-promotion-title">
                                                    <h3 data-testid="promotion-title">{promotion.title}</h3>
                                                </div>
                                            </div>
                                            <div className="margin-top-1x">
                                                <PromotionEditor data={{ languageCode, promotion }} events={{ handleUpdate: this.handlePromotionUpdate }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            
                        </div>
                    </div>
                    : null
                }
                {error && error.trim().length > 0 ?
                    <ErrorAlert 
                        error={error} 
                        isShowAlert={(error && error.trim().length > 0)} 
                        closeAlert={() => this.props.events && this.props.events.onAlertClose && this.props.events.onAlertClose()} 
                    />
                    : null
                }
            </>
        );
    }
    
}

const mapStateToProps = (state) => ({
    customQuote: state.customQuote
});

export default connect(mapStateToProps)(withLocalizer(CustomizeQuoteSteFour));
